import { Card } from 'layouts'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useState, useEffect } from 'react'
import { setStroage, getStroage } from 'utils'
import { WeekFullCalendar } from './WeekFullCalendar'
import { DayFullCalendar } from './DayFullCalendar'
import { YearFullCalendar } from './YearFullCalendar'

// 其他插件...
export const ComFullCalendar = ({ dayProps, weekProps, monthProps, typeRoute, typeSlice }) => {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const [btnType, setBtnType] = useState('') // 按钮类型
    const language = getStroage('language')
    const userInfo = useSelector(state => state.HeaderSlice.userInfo)

    // 三个按钮点击切换值
    const changeBtnType = info => {
        dispatch(typeSlice.actions.clearListData()) // 组件卸载/更新时，清空数据
        setStroage('btnType', info)
        setBtnType(getStroage('btnType') || 'dayGridMonth')
    }

    useEffect(() => {
        if (getStroage('btnType') == null || getStroage('btnType') == []) {
            setStroage('btnType', 'dayGridDay')
        }
        isShowProjectSummaryAndHseDiary(setBtnType(getStroage('btnType')), null)
    }, [])

    // 改变按钮值

    //判断是否在项目总结和Hse日志模块内
    const isShowProjectSummaryAndHseDiary = (a, b) => {
        return typeRoute === 'project_summary' || typeRoute === 'hse_diary' ? a : b
    }

    // 判断是否在项目总结和Hse日志模块内
    const isDay = () => {
        return typeRoute === 'project_summary' || typeRoute === 'hse_diary'
    }

    if (!userInfo) return <></>

    return (
        <Card className='calendar-card'>
            {isDay() ? (
                <>
                    {isShowProjectSummaryAndHseDiary(
                        <div
                            className='dayGridBtn'
                            style={{
                                position: 'absolute',
                                top: '15px',
                                right:
                                    typeRoute === 'hse_diary'
                                        ? language === 'zh'
                                            ? '434px'
                                            : '469px'
                                        : language === 'zh'
                                        ? '168px'
                                        : '196px',
                            }}
                        >
                            <span
                                className='dayBtn'
                                style={{ color: btnType === 'dayGridDay' ? '#5885D2' : '#344050' }}
                                onClick={() => {
                                    changeBtnType('dayGridDay')
                                }}
                            >
                                {t('common.calendar.day')}
                            </span>
                            <span
                                className='weekBtn'
                                style={{
                                    color: btnType === 'dayGridWeek' ? '#5885D2' : '#344050',
                                }}
                                onClick={() => {
                                    changeBtnType('dayGridWeek')
                                }}
                            >
                                {t('common.calendar.week')}
                            </span>
                            <span
                                className='monthBtn'
                                style={{
                                    color: btnType === 'dayGridMonth' ? '#5885D2' : '#344050',
                                }}
                                onClick={() => {
                                    changeBtnType('dayGridMonth')
                                }}
                            >
                                {t('common.calendar.month')}
                            </span>
                        </div>,
                        <></>
                    )}
                    {/* 月视图 */}
                    {isShowProjectSummaryAndHseDiary(
                        btnType === 'dayGridMonth' && <YearFullCalendar {...monthProps} />,
                        null
                    )}
                    {/* 周视图 */}
                    {isShowProjectSummaryAndHseDiary(
                        btnType === 'dayGridWeek' && <WeekFullCalendar {...weekProps} />,
                        null
                    )}
                    {/* 日视图 */}
                    {isShowProjectSummaryAndHseDiary(
                        btnType === 'dayGridDay' && <DayFullCalendar {...dayProps} />,
                        null
                    )}
                </>
            ) : (
                <DayFullCalendar {...dayProps} />
            )}
        </Card>
    )
}
